import {
  planSelectionStoreSelector,
  usePlanSelectionStore,
} from '../../../stores/planSelectionStore';
import {
  sharedConfigStoreSelector,
  useSharedConfigStore,
} from '../../../stores/sharedConfigStore';
import { formatMonetaryValue, getYearlyCharge } from '../../../utils/billing';

import { PaymentInfoSectionData } from './types';
import useSelectedAddon from './useSelectedAddon';

const usePaymentInfoAddonsSection = (): PaymentInfoSectionData => {
  const selectedPlan = usePlanSelectionStore(planSelectionStoreSelector.plan);
  const yearly = usePlanSelectionStore(planSelectionStoreSelector.yearly);
  const selectedAddon = useSelectedAddon();
  const creditLimits = useSharedConfigStore(
    sharedConfigStoreSelector.creditLimits
  );

  if (!creditLimits) {
    return [];
  }

  if (!selectedAddon) {
    return [
      {
        leftText: `${creditLimits[selectedPlan]} credits/month`,
        rightText: 'Included',
      },
    ];
  }

  const period = yearly ? 'year' : 'month';
  const addonChargeAmount = {
    currency: selectedAddon.currency,
    amount: yearly
      ? getYearlyCharge(selectedAddon).amount
      : selectedAddon.amount,
  };

  if (isFinite(selectedAddon.generationCredits)) {
    return [
      {
        leftText: `${selectedAddon.generationCredits} credits/month`,
        rightText: `${formatMonetaryValue(addonChargeAmount)}/${period}`,
      },
    ];
  }

  return [
    {
      leftText: 'Unlimited AI Credits',
      rightText: `${formatMonetaryValue(addonChargeAmount)}/${period}`,
    },
  ];
};

export default usePaymentInfoAddonsSection;
